import { gql } from "graphql-tag";

export const WAITLIST_UPDATE_SETTINGS = gql`
  query FetchWaitlistUpdateSettings($id: ID!) {
    organization(id: $id) {
      id
      scheduledUpdateRequests {
        settings {
          enabled
          letterMode
          letterDelay
        }

        templates {
          id
          type
          name
          body
          html
        }
      }

      interestLists {
        id
        name
        type
        scheduledUpdate {
          enabled
        }
      }
    }
  }
`;

export const CHANGE_WAITLIST_UPDATE_SETTINGS = gql`
  mutation ChangeWaitlistUpdateSettings($id: String!, $options: WaitlistUpdateOptions!) {
    changeScheduledUpdateSettings(organizationId: $id, options: $options) {
      settings {
        enabled
        letterMode
        letterDelay
      }
    }
  }
`;

export const TOGGLE_WAITLIST_UPDATE_FOR_LIST = gql`
  mutation ToggleWaitlistUpdate($id: String!, $enabled: Boolean!) {
    changeWaitlistUpdateSettings(interestListId: $id, options: { enabled: $enabled })
  }
`;
